import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xa3B0cWt0MCB7CiAgYmFja2dyb3VuZC1jb2xvcjogIzUyMDBmZjsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xa3B0cWt0MSB7CiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tXzFrbWxtZzVhKTsKICBtYXJnaW4tdG9wOiAtNDBweDsKICBwYWRkaW5nLXRvcDogNDBweDsKfQ';
export var blurple = '_1kptqkt0';
export var background = '_1kptqkt1';